import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  width: 100vw;
  overflow-y: auto;
  /* height: 100vh; */
`;
export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-top: 4vh;
  align-items: center;
  @media ${theme.devices.tablet} {
    flex-direction: column;
  }
`;
export const LogoImg = styled.img`
  height: 3vh;
  margin-left: 7vw;
  @media ${theme.devices.tablet} {
    margin-left: 0vw;
  }
`;
